import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useNavigationStore = defineStore('navigation', () => {
  const activeSection = ref('sidebar') // 'sidebar', 'conversation', 'insights'
  const transitionName = ref('slide-left')
  const isTransitioning = ref(false)

  // Update active section and transition name
  const setActiveSection = (targetSection) => {
    if (isTransitioning.value) return
    console.log('Going from', activeSection.value, 'to', targetSection)
    activeSection.value = targetSection
    // Unlock after the transition duration (e.g., 300ms)
    setTimeout(() => {
      isTransitioning.value = false
    }, 300)
  }

  return {
    activeSection,
    transitionName,
    setActiveSection
  }
})
